const ADMIN_INFO_KEY = 'admin.adminInfo';
const PERMISSIONS_KEY = 'admin.permissions';
const MENUS_KEY = 'admin.menus';

function readJson(key, fallback) {
  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) {
      return fallback;
    }
    const parsed = JSON.parse(raw);
    return parsed != null ? parsed : fallback;
  } catch (e) {
    console.error(e);
    return fallback;
  }
}

function writeJson(key, value) {
  window.sessionStorage.setItem(key, JSON.stringify(value));
  window.localStorage.removeItem(key);
}

export default {
  namespaced: true,
  state: {
    adminInfo: {},
    permissions: [],
    menus: []
  },
  getters: {
    adminInfo: state => {
      if (!state.adminInfo || !Object.keys(state.adminInfo).length) {
        state.adminInfo = readJson(ADMIN_INFO_KEY, {});
      }
      return state.adminInfo;
    },
    permissions: state => {
      if (!state.permissions || !state.permissions.length) {
        state.permissions = readJson(PERMISSIONS_KEY, []);
      }
      return state.permissions;
    },
    menus: state => {
      if (!state.menus || !state.menus.length) {
        state.menus = readJson(MENUS_KEY, []);
      }
      return state.menus;
    }
  },
  mutations: {
    setAdminInfo(state, adminInfo) {
      state.adminInfo = adminInfo;
      writeJson(ADMIN_INFO_KEY, adminInfo);
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
      writeJson(PERMISSIONS_KEY, permissions);
    },
    setMenus(state, menus) {
      state.menus = menus;
      writeJson(MENUS_KEY, menus);
    },
  }
}
